import * as Sentry from "@sentry/react";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { l as loggerUtils } from "./loggerUtils-CebMqdva.js";
import Cookies from "universal-cookie";
const GLOBAL_COOKIES = new Cookies();
const SIGNED_IN_LD_USER_KEY_COOKIE_NAME = "ld_user_key";
function getLaunchDarklyUserKeyCookieValue() {
  return GLOBAL_COOKIES.get(SIGNED_IN_LD_USER_KEY_COOKIE_NAME, { doNotParse: true });
}
const useLaunchDarklyUpdater = () => {
  const ldClient = useLDClient();
  if (!ldClient) {
    throw new Error(
      "useLaunchDarklyUpdateUser must be used within a ConfiguredFeatureFlagsProvider context"
    );
  }
  const updateLaunchDarkly = async () => {
    const newLDUserKey = getLaunchDarklyUserKeyCookieValue();
    const currentLdUserKey = ldClient.getUser().key;
    if (newLDUserKey === currentLdUserKey) {
      return;
    }
    const user = newLDUserKey ? { key: newLDUserKey } : { anonymous: true };
    try {
      await ldClient.identify(user);
    } catch (error) {
      Sentry.withScope((scope) => {
        scope.setTag("subsystem", "feature-flags");
        loggerUtils.logException(error);
      });
    }
  };
  return { updateLaunchDarkly };
};
export {
  getLaunchDarklyUserKeyCookieValue as g,
  useLaunchDarklyUpdater as u
};
//# sourceMappingURL=useLaunchDarklyUpdater-qS2r1zS0.js.map
